<div class="detail-authority">
  <p class="back-link" (click)="showAuthorities()">
    <span><i class="pi pi-angle-left"></i></span>
    <span>Back</span>
  </p>
  <br />
  <div class="detail-heading-data" *ngIf="!isMobile">
    <div class="col-left-heading-data">
      <span class="authority-id">Authority #{{ authorityData.ec1Number }}</span>
      <span class=""
        >Status: <span class="check-icon"><i class="csx-common_check"></i></span></span
      ><br />
      <span>
        Effective: <span class="effective-date">{{ authorityData.effective | estDate | date: 'MM/dd/yyyy HH:mm' }}</span></span
      >
    </div>
    <div class="col-right-heading-data">
      <span>Until: {{ authorityData.expiration | estDate | date: 'MM/dd/yyyy HH:mm' }}</span
      ><br />
      <span *ngIf="authorityData.dispatcher"> Dispatcher: {{ authorityData.dispatcher }}</span>
      <br />
      <span> RWIC: {{ authorityData.primaryUserDetail.eicUserId }} - {{ authorityData.primaryUserDetail.eicEmployeeName }}</span>
    </div>
  </div>
  <div *ngIf="isMobile" class="authority-mobile">
    <div class="display-block">
      <span class="authority-id">Authority #{{ authorityData.ec1Number }}</span>
      <span class=""
        >Status: <span class="check-icon"><i class="csx-common_check"></i></span
      ></span>
    </div>
    <div class="display-block" *ngIf="authorityData.dispatcher">Dispatcher: {{ authorityData.dispatcher }}</div>
    <div class="display-block">
      RWIC: {{ authorityData.primaryUserDetail.eicUserId }} - {{ authorityData.primaryUserDetail.eicEmployeeName }}
    </div>
    <div class="display-block">Until: {{ authorityData.expiration | estDate | date: 'MM/dd/yyyy HH:mm' }}</div>
    <div class="display-block">
      Effective:<span class="highlighted"> {{ authorityData.effective | estDate | date: 'MM/dd/yyyy HH:mm' }}</span>
    </div>
  </div>

  <div class="detail-lines">
    <ul class="line-item-wrapper">
      <li *ngFor="let lineItem of authorityData.lineItems">
        <detail-authority-card *ngIf="!isMobile" [lineItem]="lineItem"></detail-authority-card>
        <detail-authority-card-mobile *ngIf="isMobile" [lineItem]="lineItem"></detail-authority-card-mobile>
      </li>
    </ul>

    <div
      class="additional-line"
      *ngFor="let crossOver of authorityData.crossOvers"
      [hidden]="crossOver.cancelledDate"
      [ngClass]="{ 'mobile-pad-line': isMobile }"
    >
      <div class="table-column column-line">
        <span *ngIf="isMobile">Line:</span><span>{{ crossOver.lineNumber }}</span>
      </div>
      <div class="table-column crossover">
        <i class="csx-arrows_switching"></i>
        <span class="highlighted">{{ crossOver.location + ' ' + crossOver.fromTrack.name + ' -> ' + crossOver.toTrack.name }}</span>
      </div>
    </div>
    <hr *ngIf="line11Items.length > 0 || commentList.length > 0" />
    <br />

    <div class="authority-comment" *ngFor="let comment of line11Items; let i = index" [ngClass]="{ 'mobile-margin-comment': isMobile }">
      <div class="table-column column-line">
        <span *ngIf="i === 0">Line 11</span>
      </div>
      <p class="highlighted-comment">{{ comment.text }}</p>
    </div>
    <div
      *ngFor="let comment of commentList; let i = index"
      class="authority-comment {{ comment.type | lowercase }}"
      [ngClass]="{ 'mobile-margin-comment': isMobile }"
    >
      <div class="comment-wrapper" *ngIf="comment.type === 'DISPATCHER' || comment.type === 'PRIVATE'">
        <span>{{ comment.text }}</span>
      </div>
    </div>
  </div>
</div>
